// M2 — Manager tour: Managing Inquiries. 3 steps on /inquiries.
export default {
  key: 'M2',
  route: '/inquiries',
  steps: [
    {
      id: 'list',
      target: '[data-tour-id="inquiries.list.table"]',
      title: 'Inquiries list',
      desc: 'The Inquiries screen shows every incoming customer request. Open one to view, edit, update its status, or generate and send a formal offer to the customer.',
    },
    {
      id: 'status-filter',
      target: '[data-tour-id="inquiries.status-filter"]',
      title: 'Status workflow',
      desc: 'Each inquiry moves through statuses — Open, OfferSent, OfferAccepted, ConvertedToOrder. Use this filter to narrow the list by status.',
    },
    {
      id: 'convert',
      target: '[data-tour-id="inquiries.list.table"]',
      title: 'Create an order from an inquiry',
      desc: 'Open an OfferAccepted inquiry and use "Create order from entire inquiry" to generate the production order. The inquiry status then becomes ConvertedToOrder.',
    },
  ],
}
